// 登录设备模块 - 简体中文
export default {
  tabs: {
    summary: "登录IP汇总",
    details: "登录IP明细",
    device: "设备明细",
  },
  common: {
    totalPrefix: "共计",
    totalSuffix: "条数据",
    download: "下载",
    downloadFilename: "数据明细",
    loading: "拼命加载中",
    empty: "暂无数据",
  },
  placeholders: {
    inputIpLocation: "请输入IP地理位置",
  },
  columns: {
    ipAddress: "ip地址",
    ipLocation: "IP地理位置",
    loginCount: "登录次数",
    lastLoginTime: "最近登录时间",
    port: "端口",
    loginTime: "登录时间",
    loginWay: "登录方式",
    deviceName: "设备名",
    deviceId: "Device ID (UUID)",
    client: "客户端",
    imei: "IMEI",
    mac: "MAC",
  },
};
